import type { Route } from '@application/types';
import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { JoinProInfoPageType } from '@presentation/pages';

export const PRO_ROUTES: Route[] = [
  'groomer',
  'groomerList',
  'vet',
  'vetList',
  'educator',
  'educatorList',
  'proLanding',
];

export const PRO_DEFAULT_OG_IMAGE_ROUTES: Route[] = [
  'groomerList',
  'vetList',
  'educatorList',
  'proLanding',
];

export const PRO_IGNORE_OG_IMAGE_ROUTES: Route[] = ['groomer', 'vet', 'educator'];

export const JOIN_PRO_ROUTES: Route[] = [
  'joinVet',
  'joinGroomer',
  'joinProInfoAgendaVet',
  'joinProInfoBookingVet',
  'joinProInfoProfileVet',
  'joinProInfoSeoVet',
  'joinProInfoAgendaGroomer',
  'joinProInfoBookingGroomer',
  'joinProInfoProfileGroomer',
  'joinProInfoSeoGroomer',
  'joinEducator',
];

export const JOIN_VET_ROUTES: Route[] = [
  'joinVet',
  'joinProInfoAgendaVet',
  'joinProInfoBookingVet',
  'joinProInfoProfileVet',
  'joinProInfoSeoVet',
];

export const JOIN_GROOMER_ROUTES: Route[] = [
  'joinGroomer',
  'joinProInfoAgendaGroomer',
  'joinProInfoBookingGroomer',
  'joinProInfoProfileGroomer',
  'joinProInfoSeoGroomer',
];

export const MY_TIPAW_ROUTES: Route[] = [
  'mtProfile',
  'mtOnboarding',
  'mtPage',
  'mtBreederProfile',
  'mtAdoptions',
  'mtAppointments',
  'mtAnimals',
  'mtLitters',
  'mtWishlist',
  'mtMessages',
  'mtFaq',
  'mtSettings',
  'mtPayments',
  'mtLanding',
  'mtApplications',
  'mtApplicationCheckoutFailed',
  'mtApplicationCheckoutSuccess',
  'mtOwners',
  'mtWaitingList',
  'mtFaq',
  'mtAdvantages',
  'mtPuppyGuide',
  'mtContact',
];

export const JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE: Record<
  ProfessionalTypeEnum,
  Record<JoinProInfoPageType, Route>
> = {
  GROOMER: {
    AGENDA: 'joinProInfoAgendaGroomer',
    BOOKING: 'joinProInfoBookingGroomer',
    SEO: 'joinProInfoSeoGroomer',
    PROFILE: 'joinProInfoProfileGroomer',
  },
  VET: {
    AGENDA: 'joinProInfoAgendaVet',
    BOOKING: 'joinProInfoBookingVet',
    SEO: 'joinProInfoSeoVet',
    PROFILE: 'joinProInfoProfileVet',
  },
  EDUCATOR: {
    AGENDA: 'joinEducator',
    BOOKING: 'joinEducator',
    SEO: 'joinEducator',
    PROFILE: 'joinEducator',
  },
};

export const PRO_PAGE_ROUTE_PER_PRO_TYPE: Record<ProfessionalTypeEnum, Route> = {
  GROOMER: 'groomer',
  VET: 'vet',
  EDUCATOR: 'educator',
};

export const LIGHTBOX_ROUTES: Route[] = [
  'litter',
  'mtMessages',
  'breeder',
  'educator',
  'vet',
  'groomer',
  'shelter',
  'stud',
  'application',
];

export const APPLICATION_MESSAGE_ROUTES: Route[] = [
  'application',
  'mtApplications',
  'mtMessages',
  'stud',
];

export const VET_ADVICE_ROUTES: Route[] = [
  'articleList',
  'breedList',
  'breedComparator',
  'homeLanding',
  'litter',
  'quizResults',
];

export const FREE_APPLICATIONS_MODAL_ROUTES: Route[] = ['login', 'joinBuyer', 'mtLanding'];
export const WHATS_APP_MODAL_ROUTES: Route[] = ['breeder', 'vet', 'groomer', 'educator', 'litter'];
export const LITTER_UPDATE_MODAL_ROUTES: Route[] = [
  'mtLanding',
  'mtLitters',
  'mtApplications',
  'mtMessages',
  'mtProfile',
];
export const MT_BREEDER_STORE_PARTNERSHIP_MODAL_ROUTES: Route[] = [
  'mtLanding',
  'mtAdvantages',
  'mtApplications',
  'mtMessages',
  'mtLitters',
  'mtProfile',
  'mtAnimals',
  'mtWaitingList',
];
export const RESET_PASSWORD_MODAL_ROUTES: Route[] = [
  'mtSettings',
  'login',
  'joinBuyer',
  'joinBreeder',
  'joinLanding',
  'resetPassword',
  'booking',
];
export const CHANGE_PASSWORD_MODAL_ROUTES: Route[] = ['mtSettings', 'resetPassword'];

export const SOCIAL_SHARE_MODAL_ROUTES: Route[] = [
  'breeder',
  'article',
  'litter',
  'shelter',
  'article',
  'articleList',
];
export const AUTH_MODAL_ROUTES: Route[] = [
  'litter',
  'breeder',
  'breederReview',
  'educator',
  'educatorReview',
];

export const SOCIAL_LOGIN_MODAL_ROUTES: Route[] = [
  'mtSettings',
  'login',
  'joinBuyer',
  'joinBreeder',
  'joinLanding',
  'application',
];

export const BUYER_CHECKLIST_MODAL_ROUTES: Route[] = ['breeder', 'litter'];
export const APPLICATION_EXISTS_MODAL_ROUTES: Route[] = [
  'breeder',
  'litter',
  'stud',
  'application',
];

export const BREEDER_OVERVIEW_MODAL_ROUTES: Route[] = ['application'];
